let theme = {

  blue:                     '#3300A6',
  lightBlue:                '#042C71',


  textPrimary:              '#232931',

  transparent:              'transparent',
  black:                    '#000000',
  white:                    '#ffffff',

  bgGray:                   '#fafafa',
  bgBlue:                   '#EBEEF0',

  boxShadow:                'rgba(32,32,32,0.05) 0px 0px 30px 0px',

  baseFont: '"Crete Round", serif',
  secondaryFont: '"Montserrat Alternates", sans-serif',

  shortNavHeight: '65px',
  tallNavHeight: '90px',

  small: {
    outer: '320px',
    inner: '320px',
    start: '0px',
    end: ' 640px',
  },
  medium: {
    inner: '768px',
    start: '768px',
    end: '1024px',
  },
  large: {
    before: '1139px',
    inner: '1140px',
    start: '1141px',
    end: '1440px',
  },
  xlarge: {
    outer: '1440px',
    inner: '1140px',
    start: '1441px',
  },
}

export default theme



// WEBPACK FOOTER //
// ./src/theme.js